import React from "react"
import {Route, Switch, BrowserRouter as Router} from "react-router-dom"
import Login from "./containers/Login"
import Recovery from "./containers/Login/recovery"
import Saml from "./containers/Login/saml"
import Home from "./containers/Home"
import InteligentJourneyRoutes from "./containers/InteligentJourney"
import CapturaRoutes from "./containers/Captura"
import RepoRoutes from "./containers/Repositorio"
// import Logout from "containers/Logout"

const getRoute = (route) => (
    <Route
        exact
        path={route.path}
        component={(props) => <route.component {...props} />}
    />
)

export default () => (
    <Router>
        <Switch>
            <Route
                exact
                path="/"
                component={(props) => <Login {...props} name={process.env.REACT_APP_NAME_SYSTEM}/>}
            />
            <Route
                path="/recovery/:code"
                component={(props) => <Recovery {...props} name={process.env.REACT_APP_NAME_SYSTEM}/>}
            />
            <Route

                path="/saml"
                component={(props) => <Saml {...props} name={process.env.REACT_APP_NAME_SYSTEM}/>}
            />

            {InteligentJourneyRoutes.map((route) => {
                return getRoute(route)
            })}
            {CapturaRoutes.map((route) => {
                return getRoute(route)
            })}
            {RepoRoutes.map((route) => {
                return getRoute(route)
            })}

            <Route path="/home" exact component={(props) => <Home {...props} />}/>
            {/* <Route path="/sair" exact component={(props) => <Logout {...props} />} /> */}
        </Switch>
    </Router>
)
